import React from "react";
import "./Choose.css";
import {
  FaBuilding,
  FaLeaf,

  FaDollarSign,
  FaUsers,

} from "react-icons/fa";
import { Link } from "react-router-dom";

const FEATURE_ITEMS = [
  {
    id: 1,
    icon: <FaBuilding className="feature__icon-svg" />,
    title: "HOA & Commercial Specialists",
    subtitle: "Expertise in large-scale community and commercial landscapes"
  },
  {
    id: 2,
    icon: <FaLeaf className="feature__icon-svg" />,
    title: "Native Plant Experts",
    subtitle: "Right plants for our local climate and environment"
  },
  {
    id: 3,
    icon: <FaDollarSign className="feature__icon-svg" />,
    title: "Value-Focused Solutions",
    subtitle: "Cost-effective options for flippers and real estate prep"
  },
  {
    id: 4,
    icon: <FaUsers className="feature__icon-svg" />,
    title: "Seamless Service",
    subtitle: "One dedicated team handles design through installation"
  }
];

export default function Choose() {
  const imageUrl = `${process.env.PUBLIC_URL}/IMG_4534.jpeg`;

  return (
    <section className="choose" id="choose-us">
      <div className="choose__inner container">
        {/* Left side: text & features */}
        <div className="choose__content">
          <small className="choose__eyebrow">Why Choose Us</small>

          <h2 className="choose__title">
            Building <span className="highlight">trust through expertise</span> in every landscape
          </h2>

          <p className="choose__text">
             From ongoing property maintenance to complex hardscape construction, 
            our work is built around consistency, durability, and clear communication. 
            We focus on keeping landscapes healthy, functional, and visually strong year-round, 
            while constructing hardscape features that are designed to last and perform as intended.
          </p>

          <div className="choose__features">
            {FEATURE_ITEMS.map(({ id, icon, title, subtitle }) => (
              <article className="feature" key={id}>
                <div className="feature__icon-wrapper">{icon}</div>
                <h3 className="feature__title">{title}</h3>
                <p className="feature__subtitle">{subtitle}</p>
              </article>
            ))}
          </div>

          <Link to="/contact" className="choose__btn">
            Get a free quote <span className="btn-arrow">→</span>
          </Link>
        </div>

        {/* Right side: hero image */}
        <figure className="choose__image-wrapper">
          <div className="choose__image-overlay"></div>
          <img
            src={imageUrl}
            alt="Professional landscaping team working on commercial property"
            className="choose__image"
            loading="lazy"
          />
        </figure>
      </div>
    </section>
  );
}
